<template>
  <div class="w-100">
    <div class="item w-100" :class="{ editFalse: edit == false ? true : false }">
      <div class="item_text f16">
        {{
          type === 'responsible'
            ? item.employee.user.first_name + ' ' + item.employee.user.last_name
            : item.user.first_name + ' ' + item.user.last_name
        }}
      </div>
      <div class="item_btn">
        <DeleteModal
          v-if="edit"
          :text="
            (type === 'responsible'
              ? localStorage.translations.pages.sales_project[
                  'planned_resources-responsible_employees-delete'
                ]['udalit-otvetstvennoe-litso']
              : localStorage.translations.pages['sales_project']['planned_resources-subscribers']
                  .delete_project) +
            ' ' +
            (type === 'responsible'
              ? item.employee.user.first_name + ' ' + item.employee.user.last_name
              : item.user.first_name + ' ' + item.user.last_name)
          "
          :methodDelete="onDeleteItem"
        />
      </div>
    </div>
    <div v-if="type === 'responsible' && userType !== 'subscriber'" class="w-100 mt-5">
      <BaseTableView
        :head="[
          { text: localStorage.translations.pages.sales_project['planned_resources-labels']['hourly_premium'] },
          { text: localStorage.translations.pages.sales_project['planned_resources-labels']['unit_premium'] },
          { text: localStorage.translations.pages['setting-personal_area'].labels['changed_by'] },
          { text: localStorage.translations.pages.finance['period-table'].date },
        ]"
        list-view="mdAndUp"
        :sticky="false"
      >
        <tr>
          <td>
            <BaseInput
              v-model="item['hour_salary']"
              placeholder="—"
              max-width="350px"
              input-type="number"
              @input="onlyNumbers($event, 'item[\'hour_salary\']')"
              :view="$userCheckAccess({ abilities: 'view_all_client_project' && 'edit_employee_salary' }) ? !edit : true"
              :view-value="item['hour_salary'] ? item['hour_salary'].toLocaleString('fi-FI', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) +' €/' +localStorage.translations.pages.common.measure.hours_min : '-'"
            >
              <template v-slot:append-outer>
                <div class="mt-1 text-pre">
                  {{ '€/' + localStorage.translations.pages.common.measure.hours_min }}
                </div>
              </template>
            </BaseInput>
          </td>
          <td>
            <BaseInput
              v-model="item['unit_salary']"
              placeholder="—"
              max-width="350px"
              input-type="number"
              @input="onlyNumbers($event, 'item[\'unit_salary\']')"
              :view="$userCheckAccess({ abilities: 'view_all_client_project' }) ? !edit : true"
              :view-value="item['unit_salary'] ? item['unit_salary'].toLocaleString('fi-FI', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) +' €/' + localStorage.translations.pages.common.measure['piece'] : '-'"
            >
              <template v-slot:append-outer>
                <div class="mt-1 text-pre">
                  {{ '€/' + localStorage.translations.pages.common.measure['piece'] }}
                </div>
              </template>
            </BaseInput>
          </td>
          <td>
            {{ item.changer ? item.changer.first_name + ' ' + item.changer.last_name : '—'}}
          </td>
          <td>
            {{ item.updated_at ? item.updated_at : '—'}}
          </td>
        </tr>
      </BaseTableView>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'ProjectPlannedResourcesResponsibleAndSubscribersWrapItem',
  components: { DeleteModal },
  props: {
    item: Object,
    edit: Boolean,
    type: String,
  },
  computed: {
    ...mapGetters('user', ['userType']),
  },
  methods: {
    ...mapActions('workClientProjectsResponsibleEmployees', [
      'onWorkClientProjectsResponsibleEmployeesAll_project',
      'onWorkClientProjectsResponsibleEmployeesDelete',
    ]),
    ...mapActions('workClientProjectsSubscribers', [
      'onWorkClientProjectsSubscribersAll_project',
      'onWorkClientProjectsSubscribersDelete',
    ]),
    onDeleteItem() {
      this[
        this.type === 'responsible'
          ? 'onWorkClientProjectsResponsibleEmployeesDelete'
          : 'onWorkClientProjectsSubscribersDelete'
      ]({ id: this.item.id })
        .then((response) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
              IsError: false,
            },
            { root: true },
          )
          this[
            this.type === 'responsible'
              ? 'onWorkClientProjectsResponsibleEmployeesAll_project'
              : 'onWorkClientProjectsSubscribersAll_project'
          ]({
            project_id: this.$route.params.id,
          })
        })
        .catch((err) => {
          console.log(err)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
    onlyNumbers(event, vModel) {
      let result = event.replace(/[^0-9,.]/g, '').replace(/,/g, '.')
      this[vModel] = parseFloat(result)
    },
  },
}
</script>

<style lang="scss" scoped>
.item {
  display: grid;
  grid-template-columns: repeat(2, max-content);
  justify-content: space-between;
  align-items: center;
  transition: 0.3s;
  background-color: #277faf;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  padding: 6px 12px;
  border-radius: 20px;
  flex: 0 1 auto;

  &_text {
    color: #ffffff;
  }

  .item_btn:deep() {
    // padding: 20px;
    .delete_button {
      margin-left: 10px;
      padding: 5px;

      svg {
        path {
          fill: #ffffff;
        }
      }

      &:hover {
        svg {
          path {
            fill: red;
          }
        }
      }
    }
  }
}
:deep() tbody {
  tr {
    td {
      width: 200px;
      
      &:first-of-type {
        width: 250px;
      }
    }
  }
}
</style>